import { createSelector } from 'reselect';
import {
  mapDashboardDataToChartView,
  mapDashboardDataToCumulLastDayAnnual,
} from 'helpers/chartDataMappers';
import { selectCurrentCompanyFirstFiscalMonth } from 'modules/turnoverPage/selectors';
import { selectUserCurrentCompanyExercice } from '../../loggedUserInfo/selectors';

export const selectDebtorsStatus = (state) => state.debtors?.status;

export const selectDebtors = (state) => state.debtors?.data || [];

export const selectDebtorPageData = createSelector(
  [(state) => state.debtors?.current],
  (pageInfo) => {
    if (!pageInfo) return { data: [] };

    const { data, ...rest } = pageInfo;
    return {
      ...rest,
      data: data || [],
    };
  }
);

export const selectDebtorsDatasets = (state) => state.debtors?.datasets || [];

export const selectDebtorsLastUpdated = (state) =>
  state.debtors?.lastUpdated || new Date(Date.now()).toISOString();

export const selectDebtorsDataForCharts = createSelector(
  [selectDebtorsDatasets, selectUserCurrentCompanyExercice],
  (debtorsDatasets, currentExercice) =>
    mapDashboardDataToChartView(debtorsDatasets, 'debts', currentExercice)
);

export const selectDebtorsYearData = createSelector(
  [selectCurrentCompanyFirstFiscalMonth, selectDebtorsDataForCharts],
  (firstMonthName, debtorsChartData) =>
    mapDashboardDataToCumulLastDayAnnual(debtorsChartData, firstMonthName)
);
